import { useTheme } from "context/ThemeContext";
import SolarMoonBoldDuotone from "../icons/SolarMoonBoldDuotone";
import SolarSun2BoldDuotone from "../icons/SolarSun2BoldDuotone";

const ThemeButton = () =>{
    
    const { darkTheme, setDarkTheme } = useTheme();

    const handleClickTheme = () => {
        setDarkTheme(!darkTheme)
    }

    return (
        <div className="pc-h-item ">
            <span className="pc-head-link ms-0 cursor-pointer"
                onClick={handleClickTheme}>
                {darkTheme 
                    ? (<SolarSun2BoldDuotone/>)
                    : (<SolarMoonBoldDuotone/>)} 
            </span>
        </div>
    )
}

export default ThemeButton;